import React, { useState } from 'react';
import './HostingWindows.css';

const HostingWindows = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const plans = [
    {
      tier: 'شخصی',
      price: '۲۰۰',
      unit: 'هزار تومان / ماه',
      disk: '۱۰ گیگابایت SSD',
      domains: '۱ دامنه',
      features: ['ASP.NET Core', 'MSSQL Express', 'پشتیبانی ۲۴/۷', 'Plesk Control Panel'],
      popular: false,
      soon: true,
    },
    {
      tier: 'کسب‌وکار',
      price: '۳۵۰',
      unit: 'هزار تومان / ماه',
      disk: '۲۵ گیگابایت SSD',
      domains: '۵ دامنه',
      features: ['ASP.NET Core', 'MSSQL Standard', 'پشتیبانی ۲۴/۷', 'Plesk Control Panel', 'بکاپ روزانه'],
      popular: true,
      soon: true,
    },
    {
      tier: 'سازمانی',
      price: '۶۰۰',
      unit: 'هزار تومان / ماه',
      disk: '۵۰ گیگابایت SSD',
      domains: 'نامحدود دامنه',
      features: ['ASP.NET Core', 'MSSQL Enterprise', 'پشتیبانی ۲۴/۷', 'Plesk Control Panel', 'بکاپ روزانه', 'IP اختصاصی'],
      popular: false,
      soon: true,
    },
  ];

  const features = [
    {
      icon: '🪟',
      title: 'پشتیبانی کامل از ASP.NET Core',
      desc: 'هاست ویندوز افرسل با پشتیبانی کامل از ASP.NET Core، شما می‌توانید اپلیکیشن‌های دات‌نت خود را به راحتی روی سرورهای ما اجرا کنید. پشتیبانی از تمام نسخه‌های دات‌نت و امکانات پیشرفته.',
    },
    {
      icon: '🗄️',
      title: 'پایگاه داده MSSQL با عملکرد بالا',
      desc: 'استفاده از پایگاه داده Microsoft SQL Server با عملکرد بالا و امنیت عالی. مناسب برای اپلیکیشن‌های سازمانی و پروژه‌های بزرگ.',
    },
    {
      icon: '🎛️',
      title: 'کنترل پنل Plesk حرفه‌ای',
      desc: 'مدیریت کامل وب‌سایت خود با کنترل پنل Plesk. رابط کاربری ساده و قدرتمند با امکانات کامل برای مدیریت دامنه، ایمیل و پایگاه داده.',
    },
    {
      icon: '🛡️',
      title: 'امنیت پیشرفته ویندوز',
      desc: 'سرورهای ویندوز با به‌روزرسانی خودکار امنیتی و فایروال پیشرفته، از وب‌سایت شما در برابر تهدیدات سایبری محافظت می‌کنند.',
    },
  ];

  const faqs = [
    {
      q: 'هاست ویندوز چه تفاوتی با هاست لینوکس دارد و برای چه پروژه‌هایی مناسب است؟',
      a: 'هاست ویندوز با سیستم‌عامل Windows Server و پشتیبانی از فناوری‌های مایکروسافت مانند ASP.NET، MSSQL و IIS طراحی شده است. این نوع هاست برای وب‌سایت‌ها و اپلیکیشن‌هایی که با زبان‌های دات‌نت (C#, VB.NET) نوشته شده‌اند، ضروری است. همچنین برای سازمان‌هایی که از اکوسیستم مایکروسافت استفاده می‌کنند، گزینه‌ای ایده‌آل محسوب می‌شود. هاست ویندوز به زودی در افرسل راه‌اندازی می‌شود.',
    },
    {
      q: 'آیا هاست ویندوز از ASP.NET Core پشتیبانی می‌کند؟',
      a: 'بله، هاست ویندوز افرسل با پشتیبانی کامل از ASP.NET Core، شما می‌توانید اپلیکیشن‌های دات‌نت خود را روی سرورهای ما اجرا کنید. همچنین از نسخه‌های قدیمی‌تر ASP.NET نیز پشتیبانی می‌شود. کنترل پنل Plesk نیز مدیریت آسان وب‌سایت شما را فراهم می‌کند.',
    },
  ];

  return (
    <>
      <div className="seo-header">
        <h1>هاست ویندوز | خرید هاست ویندوز با بهترین قیمت | افرسل</h1>
        <p>خرید هاست ویندوز با سرورهای SSD، پشتیبانی از ASP.NET Core و MSSQL. هاست ویندوز مناسب برای اپلیکیشن‌های دات‌نت و وب‌سایت‌های سازمانی. (به زودی)</p>
        <meta name="description" content="خرید هاست ویندوز با بهترین قیمت از افرسل. هاست ویندوز با ASP.NET Core، MSSQL، Plesk Control Panel و پشتیبانی ۲۴/۷. (به زودی)" />
      </div>

      <section className="hosting-windows-hero">
        <div className="hosting-windows-hero-bg"></div>
        <div className="wrap">
          <div className="hosting-windows-hero-content">
            <div className="hosting-windows-badge">
              <span className="pulse-dot"></span>
              🪟 هاست ویندوز <span style={{ fontSize: '0.7rem', backgroundColor: 'rgba(249,115,22,0.3)', padding: '2px 10px', borderRadius: '999px', marginRight: '8px' }}>به زودی</span>
            </div>
            <h1 className="hosting-windows-hero-title">
              هاست <em>ویندوز</em>
            </h1>
            <p className="hosting-windows-hero-desc">
              هاست ویندوز با سرورهای SSD، پشتیبانی از ASP.NET Core و MSSQL.
              مناسب برای اپلیکیشن‌های دات‌نت، وب‌سایت‌های سازمانی و پروژه‌های مبتنی بر فناوری‌های مایکروسافت.
              <br />
              <span style={{ color: 'var(--orange)', fontWeight: '700' }}>⚡ به زودی در افرسل</span>
            </p>
            <div className="hosting-windows-hero-stats">
              <div className="stat-item">
                <span className="stat-number">۳</span>
                <span className="stat-label">پلن مختلف</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">MSSQL</span>
                <span className="stat-label">پایگاه داده</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">ASP.NET</span>
                <span className="stat-label">پشتیبانی کامل</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="hosting-windows-plans">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">پلن‌های هاست ویندوز</span>
            <h2 className="sec-h">پلن <em>مناسب</em> وب‌سایت خود را انتخاب کنید</h2>
            <p className="sec-p">پلن‌های متنوع هاست ویندوز با قیمت‌های رقابتی و منابع کافی برای هر نوع وب‌سایت سازمانی.</p>
          </div>
          <div className="hosting-windows-plans-grid">
            {plans.map((plan, i) => (
              <div key={i} className={`hosting-windows-plan ${plan.popular ? 'popular' : ''} soon`}>
                {plan.popular && <span className="hosting-windows-popular-badge">پرفروش‌ترین</span>}
                <span className="hosting-windows-soon-badge">به زودی</span>
                <div className="hosting-windows-plan-tier">{plan.tier}</div>
                <div className="hosting-windows-plan-price">
                  <span className="hosting-windows-plan-num">{plan.price}</span>
                  <span className="hosting-windows-plan-unit">{plan.unit}</span>
                </div>
                <div className="hosting-windows-plan-specs">
                  <div><span>💾</span> {plan.disk}</div>
                  <div><span>🌐</span> {plan.domains}</div>
                </div>
                <ul className="hosting-windows-plan-features">
                  {plan.features.map((feat, j) => (
                    <li key={j}><span>✓</span> {feat}</li>
                  ))}
                </ul>
                <button className="hosting-windows-order-btn" onClick={() => scrollTo('contact')} disabled>پیش‌ثبت نام</button>
              </div>
            ))}
          </div>
          <p className="hosting-windows-note">* هاست ویندوز به زودی راه‌اندازی می‌شود. برای اطلاع از تاریخ دقیق، در خبرنامه ما عضو شوید.</p>
        </div>
      </section>

      <section className="hosting-windows-features">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">مزایای هاست ویندوز</span>
            <h2 className="sec-h">چرا <em>هاست ویندوز</em> با افرسل؟</h2>
            <p className="sec-p">هاست ویندوز با بهترین امکانات و خدمات برای اپلیکیشن‌های دات‌نت و وب‌سایت‌های سازمانی.</p>
          </div>
          <div className="hosting-windows-features-grid">
            {features.map((feature, i) => (
              <div key={i} className="hosting-windows-feature-card">
                <span className="hosting-windows-feature-icon">{feature.icon}</span>
                <h3 className="hosting-windows-feature-title">{feature.title}</h3>
                <p className="hosting-windows-feature-desc">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="hosting-windows-faq">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">سوالات متداول</span>
            <h2 className="sec-h">پاسخ به <em>سوالات</em> شما</h2>
          </div>
          <div className="hosting-windows-faq-grid">
            {faqs.map((faq, i) => (
              <div key={i} className="hosting-windows-faq-item">
                <div className="hosting-windows-faq-q">{faq.q}</div>
                <div className="hosting-windows-faq-a">{faq.a}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="hosting-windows-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              هاست <em>ویندوز</em> را پیش‌ثبت نام کنید
            </h2>
            <p className="cta-desc">
              هاست ویندوز به زودی در افرسل راه‌اندازی می‌شود. برای دریافت اطلاعیه و تخفیف ویژه،
              اطلاعات خود را ثبت کنید.
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('contact')}>پیش‌ثبت نام</button>
              <button className="btn-lg ghost" onClick={() => scrollTo('contact')}>مشاوره رایگان</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HostingWindows;
